// 根据 report_type 过滤各个报告的默认配置项
import moment from 'moment'
export const filterDefaultCustomReportGlobalConfig = (reportType, hasCheckBackgroundColorKey) => {
  const reportTypeMap = {
    10: taxRisk,
    13: dueDiligence,
    27: invest_dueDiligence,
    15: fiscal_subsidies,
    29: taxRiskProfessional,
    // 陈明辉-融资服务-后期全局搜索修改的值
    22: financeService,
    38: panoramicAnalysis,
    21: businessStrategy,
  }
  const result = reportTypeMap[reportType]
  if (reportType == 10 && !hasCheckBackgroundColorKey) {
    result.reportLogo.channelCompanyNameConfig.checkBackgroundColor = '#FFFFFF'
  }
  if (reportType == 13 && !hasCheckBackgroundColorKey) {
    result.reportLogo.channelCompanyNameConfig.checkBackgroundColor = '#ff9500'
  }
  return result
}
// 税务风险
const taxRisk = {
  reportDisplayType: 'tight',
  watermarkOpacity: 10,
  riskTip: {
    img: 'static/img/riskTip_config1.19f15420.png',
    label: '样式一',
    value: '1',
    isLabelSelect: true,
  },
  watermark: 'off',
  pageNumber: 'on',
  pageNumberPosition: 'right',
  reportLogo: {
    reportTitle: '税务风险检测',
    logoPosition: '中上',
    logoSize: 54,
    logoSizeConfig: {
      checkLogoSize: '40.5',
      checkLogoSizeObject: {
        label: '54px',
        ptValue: '40.5',
        pxValue: '54',
      },
    },
    logoPositionConfig: {
      checkClientX: '100',
      checkClientY: '100',
      useCheckPositionType: '',
    },
    reportLogoList: [
      {
        uid: 'RJFWKXCD20221213041121',
        status: 'success',
        fileURL: null,
        isHover: false,
        fileName: 'logo组合白色',
        fileType: 'png',
        isSelected: false,
      },
    ],
    currentReportLogo: {
      uid: '',
      status: '',
      fileURL: null,
      isHover: false,
      fileName: '',
      fileType: '',
      isSelected: false,
    },
    reportTitleConfig: {
      checkClientX: '130',
      checkClientY: '330',
      checkFontSize: '67.5',
      checkFontColor: '#ffffff',
      checkFontSizeObject: { label: '90px', ptValue: '67.5', pxValue: '90' },
      useCheckPositionType: 'level_center',
    },
    channelCompanyName: 'xxxx科技有限公司',
    isUseReportCreateTime: true,
    reportCreateTimeGrain: 'grain_second',
    reportCreateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    checkEnterprisePreTitle: '检测企业',
    channelCompanyNameConfig: {
      checkClientX: '257',
      checkClientY: '235',
      checkFontSize: '24',
      checkFontColor: '#060E7D',
      checkBackgroundColor: '',
      checkFontSizeObject: { label: '32px', ptValue: '24', pxValue: '32' },
      useCheckPositionType: 'level_center',
    },
    checkEnterprise: {
      checkClientX: 281,
      checkClientY: 600,
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: { label: '16px', ptValue: '12', pxValue: '16' },
      useCheckPositionType: '',
    },
    reportCreateTimePosition: {
      checkClientX: 253,
      checkClientY: '1000',
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: { label: '16px', ptValue: '12', pxValue: '16' },
      useCheckPositionType: '',
    },
    reportCreateTimePreTitle: '报告生成时间',
    javaReportCreateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
  },
  tableStyle: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/tableStyle_config1/GKNZQWZM20230209033844',
    label: '样式一',
    value: '1',
    isLabelSelect: true,
  },
  titleStyle: {
    title: '标题样式',
    config: [
      {
        value: 'tab1',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/titleStyle_firstLevel1/OMBEHDEQ20230517032020',
            label: '样式一',
            value: 'tab1_label1',
            isLabelSelect: true,
          },
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/titleStyle_firstLevel2/ZGKPZQNX20230517032045',
            label: '样式二',
            value: 'tab1_label2',
            isLabelSelect: false,
          },
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1/GJWMXFKS20230320042703',
            label: '样式三',
            value: 'tab1_label3',
            isLabelSelect: false,
          },
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/tab1_label4/IIGFWGHM20230613040027',
            label: '样式四',
            value: 'tab1_label4',
            isLabelSelect: false,
          },
        ],
        tabName: '一级标题',
        tabSelect: false,
      },
      {
        value: 'tab2',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1689320090191/FKFWDDBX20230714034111',
            label: '样式一',
            value: 'tab2_label1',
            isLabelSelect: true,
          },
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1689320591076/LILVJQUF20230714034320',
            label: '样式二',
            value: 'tab2_label2',
            isLabelSelect: false,
          },
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1689320811325/UYKXUPMG20230714034704',
            label: '样式三',
            value: 'tab2_label3',
            isLabelSelect: false,
          },
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1689320688750/BXZKNYBT20230714034501',
            label: '样式四',
            value: 'tab2_label4',
            isLabelSelect: false,
          },
        ],
        tabName: '二级标题',
        tabSelect: false,
      },
      {
        value: 'tab3',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1689321027801/HMIDHGQD20230714035049',
            label: '样式一',
            value: 'tab3_label1',
            isLabelSelect: true,
          },
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1689321137579/CNVPXBIM20230714035233',
            label: '样式二',
            value: 'tab3_label2',
            isLabelSelect: false,
          },
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1689321232085/TMCRSSFK20230714035416',
            label: '样式三',
            value: 'tab3_label3',
            isLabelSelect: false,
          },
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1689321296921/BNMJXLHX20230714035512',
            label: '样式四',
            value: 'tab3_label4',
            isLabelSelect: false,
          },
        ],
        tabName: '三级标题',
        tabSelect: false,
      },
    ],
    selectType: 'tabSelect',
  },
  labelSelect: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/%E9%A1%B5%E5%A4%B4%E6%A0%B7%E5%BC%8F%E4%B8%80/SHNNYNFQ20230418100305',
    label: '样式一',
    value: '1',
    imgConfig: {},
    isLabelSelect: true,
  },
  customUploadHeaderStyle: {
    img: '',
    type: 'customUpload',
    label: '自定义上传',
    value: '1000',
    imgConfig: {},
    isLabelSelect: false,
  },
  reportCover: {
    reportCoverList: [
      {
        uid: 'WGWLZBWY20221205042828',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/%E8%83%8C%E6%99%AF%E6%A8%A1%E6%9D%BF/QKDJDYQW20221205045240',
        isHover: false,
        fileName: '封面末班',
        fileType: 'png',
        isSelected: true,
      },
      {
        uid: 'YFWDVZTM20221208081915',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/%E6%A8%A1%E6%9D%BF2/YFWDVZTM20221208081915',
        isHover: false,
        fileName: '模板2',
        fileType: 'png',
        isSelected: false,
      },
      {
        uid: 'RBHRNCZI20221208081922',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/%E6%A8%A1%E6%9D%BF3/RBHRNCZI20221208081922',
        isHover: false,
        fileName: '模板3',
        fileType: 'png',
        isSelected: false,
      },
      {
        uid: 'CMSVUZQQ20230323031259',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/cover/CMSVUZQQ20230323031259',
        isHover: false,
        fileName: 'cover',
        fileType: 'png',
        isSelected: false,
      },
      {
        uid: 'KKGFURFR20230418112848',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/special_cover_1/KKGFURFR20230418112848',
        isHover: false,
        fileName: 'special_cover_1',
        fileType: 'png',
        isSelected: false,
      },
    ],
    currentReportCover: {
      uid: 'WGWLZBWY20221205042828',
      status: 'success',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/%E8%83%8C%E6%99%AF%E6%A8%A1%E6%9D%BF/QKDJDYQW20221205045240',
      isHover: false,
      fileName: '封面末班',
      fileType: 'png',
      isSelected: true,
    },
  },
  footerConfig: {
    // logo大小
    logoSize: 54,
    // logo大小配置对象
    logoSizeConfig: {
      checkLogoSize: '40.5',
      checkLogoSizeObject: {
        label: '54px',
        ptValue: '40.5',
        pxValue: '54',
      },
    },
    logoPositionConfig: {
      checkClientX: '370',
      checkClientY: '235',
      useCheckPositionType: '',
    },
    footerLogoImage: {},
    footerLogo: {
      uid: '',
      fileURL: null,
      isHover: false,
      fileName: '',
      fileType: '',
      isSelected: false,
    },
    otherConfig: {
      img: 'static/img/第一套尾页.b191943f.png',
      label: '样式一',
      value: '1',
      addressArea: '这是一段测试的地址',
      QRCodeDescription: '微信公众号',
      contactNumber: '138568xxxxxxx',
      isLabelSelect: true,
    },
    footerCoverList: [
      {
        uid: 'IBDSSNCI20230206034059',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/footerConfig/IBDSSNCI20230206034059',
        isHover: false,
        fileName: 'footerConfig',
        fileType: 'png',
        isSelected: true,
      },
      {
        uid: 'SGTKPITR20230206034101',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/footerConfig_style_two/SGTKPITR20230206034101',
        isHover: false,
        fileName: 'footerConfig_style_two',
        fileType: 'png',
        isSelected: false,
      },
      {
        uid: 'MNIEXSOB20230323100731',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/footer3/MNIEXSOB20230323100731',
        isHover: false,
        fileName: 'footer3',
        fileType: 'png',
        isSelected: false,
      },
      {
        uid: 'JSGLJTOD20230621095029',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/f4/JSGLJTOD20230621095029',
        isHover: false,
        fileName: 'f4',
        fileType: 'png',
        isSelected: false,
      },
    ],
    currentFooterCover: {
      uid: 'IBDSSNCI20230206034059',
      status: 'success',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/footerConfig/IBDSSNCI20230206034059',
      isHover: false,
      fileName: 'footerConfig',
      fileType: 'png',
      isSelected: true,
    },
    footerDescConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerAddressConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerTelConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
  },
  isUseLawsRule: true,
  statementInfo: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/%E5%A3%B0%E6%98%8E%E6%A0%B7%E5%BC%8F%E4%B8%80/TYIGSCZH20230418094402',
    label: '样式一',
    value: '1',
    textarea:
      '为了帮助企业有效的了解并管理，企业可能面临税务合规性不足、税收筹划不严谨等多种风险。本报告会对企业的发票结构、财报和税务指标进行全面诊断，并结合大数据分析，提供各项指标的合理范围，具体包括以下几个方面：\n\n1、发票结构异常分析：我们对企业的发票结构，包括发票种类、开票金额、客户分布等情况进行分析，并结合行业特性，提示企业可能存在的虚开、采购发票异常等问题，从而提供相应的解决方案。    \n\n2、财报指标和税务指标异常分析：在这部分内容中，我们将对企业的财报指标和税务指标进行分析，通过与同行业企业指标分布情况进行比对，发现其中的异常指标。帮助企业自身结合内部基础数据，发现可能存在的账务漏洞、可能涉及的偷逃税等问题，并提供相应的风险提示和解决方案。    \n\n 3、财税票不一致分析：在这部分内容中，我们将对企业的财务报表、税务申报情况和发票数据进行比对，发现其中的不一致情况，提醒企业可能存在的漏报、错报等问题，并提供相应的解决方案。\n\n4、本报告的财务基础指标模块、企业所得税模块的部分数据取自所得税附表。目前已支持浙江、广东、陕西、江苏、上海、天津、辽宁、贵州、内蒙古、北京、湖南（部分）、深圳（部分）、四川（部分）、山东（部分）、福建、海南、甘肃、宁波、江西已开放附表数据其它省份后续开放。\n\n本报告仅供签约客户检测企业的申报情况和税收健康状况，给企业的经营等及其他决策做参考。我司在执行本次财税风险检测业务中，遵循有关法律、客观、公正、保密的原则，对检测报告的内容作客观陈述，不构成我司对任何人、任何企业做任何保证。我司不承担使用者的任何商业风险，也不承担由于其非控因素和疏忽而引起的相应的损失和损害，检测报告内容受数据基数的限制可能会有误差，仅供参考。\n\n【时间名称解释】\n 近三年：今年、去年、前年3年度的时间周期（以财税基准日为准）\n 近四年：今年、去年、前年、大前年4年度的时间周期（以财税基准日为准）\n 近12个月：从授权日上月倒推12个月\n 近36个月：从授权日上月倒推36个月',
    isLabelSelect: true,
  },
  summaryConfig: {
    label: '样式一',
    value: 1,
    isLabelSelect: true,
    displayType: '1',
  },
  lawsRuleConfig: {
    display_mode: 'disperse',
    label: '样式一',
    value: 1,
    isLabelSelect: true,
  },
  catalogueConfig: {
    img: 'static/img/第一套目录.ee1d6ece.png',
    label: '样式一',
    value: '1',
    selectModel: '3',
    isLabelSelect: true,
    isUsePageNumbers: false,
  },
  reportWatermark: '',
  // 是否使用logo，作为水印图片
  isUseReportWatermarkImage: false,
  // 水印图片
  reportWatermarkImage: '',
  riskTipPosition: 'top',
  reportThemeColor: {
    currentReportThemeColor: '#3881F8',
    currentReportThemeColorRGB: '56, 129, 248',
  },
  summaryConfigTwo: {
    label: '样式一',
    value: 1,
    isLabelSelect: true,
  },
  tableColorConfig: {
    useColorType: 'themeColor',
    customTableColor: '#3881F8',
  },
  moduleInterpretation: {
    colorConfig: '#999999',
    fontSizeConfig: '9',
    fontSizeConfigObject: {
      label: '12px',
      ptValue: '9',
      pxValue: '12',
    },
  },
}
// 企业尽调
const dueDiligence = {
  reportDisplayType: 'tight',
  watermarkOpacity: 10,
  reportCover: {
    reportCoverList: [
      {
        uid: 'JIHJJJYY20230515065401',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligenceCover1/JIHJJJYY20230515065401',
        isHover: false,
        fileName: 'dueDiligenceCover1',
        fileType: 'png',
        isSelected: true,
        status: 'success',
      },
    ],
    currentReportCover: {
      uid: 'JIHJJJYY20230515065401',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligenceCover1/JIHJJJYY20230515065401',
      isHover: false,
      fileName: 'dueDiligenceCover1',
      fileType: 'png',
      isSelected: true,
      status: 'success',
    },
  },
  reportLogo: {
    reportLogoList: [
      {
        uid: 'RJFWKXCD20221213041121',
        status: 'success',
        fileURL: null,
        isHover: false,
        fileName: 'logo组合白色',
        fileType: 'png',
        isSelected: false,
      },
    ],
    currentReportLogo: {
      uid: 'RJFWKXCD20221213041121',
      status: 'success',
      fileURL: null,
      isHover: false,
      fileName: 'logo组合白色',
      fileType: 'png',
      isSelected: false,
    },
    logoPosition: '中上',
    logoSize: 54,
    logoSizeConfig: {
      checkLogoSize: '40.5',
      checkLogoSizeObject: {
        label: '54px',
        ptValue: '40.5',
        pxValue: '54',
      },
    },
    logoPositionConfig: {
      checkClientX: '100',
      checkClientY: '100',
      useCheckPositionType: '',
    },
    reportTitle: '企业尽调报告',
    reportTitleConfig: {
      reportTitle: '报告标题',
      checkClientX: '80',
      checkClientY: '270',
      useCheckPositionType: '',
      checkFontSize: '80.25',
      checkFontSizeObject: {
        label: '107px',
        ptValue: '80.25',
        pxValue: '107',
      },
      checkFontColor: '#FF9500',
    },
    channelCompanyName: 'xxxx科技有限公司',
    channelCompanyNameConfig: {
      checkClientX: '257',
      checkClientY: '235',
      useCheckPositionType: 'level_center',
      checkFontSize: '24',
      checkFontSizeObject: {
        label: '32px',
        ptValue: '24',
        pxValue: '32',
      },
      checkFontColor: '#060E7D',
      checkBackgroundColor: '',
    },
    checkEnterprise: {
      checkClientX: '80',
      checkClientY: '430',
      useCheckPositionType: '',
      checkFontSize: '22.5',
      checkFontSizeObject: {
        label: '30px',
        ptValue: '22.5',
        pxValue: '30',
      },
      checkFontColor: '#FF9500',
    },
    isUseReportCreateTime: true,
    reportCreateTimeGrain: 'grain_second',
    reportCreateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    javaReportCreateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
    reportCreateTimePosition: {
      checkClientX: '80',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '18',
      checkFontSizeObject: {
        label: '24px',
        ptValue: '18',
        pxValue: '24',
      },
      checkFontColor: '#ffffff',
    },
    checkEnterprisePreTitle: '检测企业',
    reportCreateTimePreTitle: '报告生成时间',
  },
  statementInfo: {
    label: '样式一',
    value: '1',
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligenceStatementInfo1/KQUFVXGC20230515065914',
    isLabelSelect: true,
    textarea:
      '1、本报告的数据基于被检测企业授权的申报表等数据，以大数据建模、数据挖掘技术为基础，对被检测企业的数据进行分析，给被检测企业的申报情况和税收健康状况提供一个客观的评价。\n\n2、本报告的财务基础指标模块、企业所得税模块的部分数据取自所得税附表。目前浙江、广东、陕西、江苏、上海、天津、辽宁、贵州、内蒙古、北京、湖南（部分）、深圳（部分）、四川（部分）、山东（部分）、福建、海南、甘肃、宁波已开放附表数据其它省份后续开放。\n\n3、我司在执行本次财税风险检测业务中，遵循有关法律、法规，恪守独立、客观、公正、保密的原则，对委托企业进行税务风险体检。\n\n4、我司对被检测企业不存在任何偏见，检测报告陈述的内容是客观的，不构成我司对任何人、任何企业做明示或暗示的观点或保证。检测报告内容受数据基数的限制可能会有误差，仅供参考。\n\n5、我司出具的检测报告中的分析、判断和结论受提供的数据、限定条件和检测方法的限制，检测报告使用者应当充分考虑检测报告中载明的假设、限定条件、特别事项说明及其对检测结论的影响。\n\n6、感谢您对我司企业财税风险检测系统信任，配合我们顺利完成了本次风险检测。',
  },
  catalogueConfig: {
    label: '样式一',
    value: '1',
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_catalogueConfig1/PMKTMBWJ20230515070417',
    isLabelSelect: true,
    selectModel: '2',
    isUsePageNumbers: false,
  },
  summaryConfig: {
    label: '样式一',
    value: 1,
    isLabelSelect: true,
    displayType: '1',
  },
  summaryConfigTwo: {
    label: '样式一',
    value: 1,
    isLabelSelect: true,
  },
  reportThemeColor: {
    currentReportThemeColor: '#FF9500',
    currentReportThemeColorRGB: '255, 149, 0',
  },
  labelSelect: {
    label: '样式一',
    value: '1',
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_labelSelect1/VTSWHPMN20230515070734',
    imgConfig: {},
    isLabelSelect: true,
  },
  customUploadHeaderStyle: {
    img: '',
    type: 'customUpload',
    label: '自定义上传',
    value: '1000',
    imgConfig: {},
    isLabelSelect: false,
  },
  riskTip: {
    img: 'static/img/riskTip_config1.19f15420.png',
    label: '样式一',
    value: '1',
    isLabelSelect: true,
  },
  riskTipPosition: 'top',
  moduleInterpretation: {
    colorConfig: '#999999',
    fontSizeConfig: '9',
    fontSizeConfigObject: {
      label: '12px',
      ptValue: '9',
      pxValue: '12',
    },
  },
  watermark: 'off',
  reportWatermark: '',
  // 是否使用logo，作为水印图片
  isUseReportWatermarkImage: false,
  // 水印图片
  reportWatermarkImage: '',
  pageNumber: 'on',
  pageNumberPosition: 'right',
  isUseLawsRule: true,
  lawsRuleConfig: {
    display_mode: 'disperse',
  },
  tableStyle: {
    label: '样式一',
    value: '1',
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/tableStyle_config1/GKNZQWZM20230209033844',
    isLabelSelect: true,
  },
  tableColorConfig: {
    useColorType: 'themeColor',
    customTableColor: '#3881F8',
  },
  titleStyle: {
    title: '标题样式',
    selectType: 'tabSelect',
    config: [
      {
        tabName: '一级标题',
        value: 'tab1',
        tabSelect: true,
        tabList: [
          {
            label: '样式一',
            value: 'tab1_label1',
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_titleStyle_firstLevel1/QUJLQFRJ20230515070930',
            isLabelSelect: true,
          },
        ],
      },
      {
        value: 'tab2',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_titleStyle_secondLevel1/QBCRTHGZ20230515072722',
            label: '样式一',
            value: 'tab2_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '二级标题',
        tabSelect: false,
      },
    ],
  },
  footerConfig: {
    // logo大小
    logoSize: 54,
    // logo大小配置对象
    logoSizeConfig: {
      checkLogoSize: '40.5',
      checkLogoSizeObject: {
        label: '54px',
        ptValue: '40.5',
        pxValue: '54',
      },
    },
    logoPositionConfig: {
      checkClientX: '370',
      checkClientY: '235',
      useCheckPositionType: '',
    },
    footerLogoImage: {},
    footerCoverList: [
      {
        uid: 'PGSKHJRS20230515071337',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_footerConfig1/PGSKHJRS20230515071337',
        isHover: false,
        fileName: 'dueDiligence_footerConfig1',
        fileType: 'png',
        isSelected: true,
      },
    ],
    currentFooterCover: {
      uid: 'PGSKHJRS20230515071337',
      status: 'success',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_footerConfig1/PGSKHJRS20230515071337',
      isHover: false,
      fileName: 'dueDiligence_footerConfig1',
      fileType: 'png',
      isSelected: true,
    },
    footerLogo: {
      uid: '',
      fileURL: null,
      isHover: false,
      fileName: '',
      fileType: '',
      isSelected: false,
    },
    otherConfig: {
      label: '样式一',
      value: '1',
      img: 'static/img/第一套尾页.b191943f.png',
      isLabelSelect: true,
      contactNumber: '138568xxxxxxx',
      addressArea: '这是一段测试的地址',
      QRCodeDescription: '微信公众号',
    },
    footerDescConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#333333',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerAddressConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerTelConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
  },
}
// 投资尽调
const invest_dueDiligence = {
  reportDisplayType: 'tight',
  watermarkOpacity: 10,
  reportCover: {
    reportCoverList: [
      {
        uid: 'VCIODECP20230613074504',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/invest_dueDiligence_cover/VCIODECP20230613074504',
        isHover: false,
        fileName: 'invest_dueDiligence_cover',
        fileType: 'png',
        isSelected: true,
      },
    ],
    currentReportCover: {
      uid: 'VCIODECP20230613074504',
      status: 'success',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/invest_dueDiligence_cover/VCIODECP20230613074504',
      isHover: false,
      fileName: 'invest_dueDiligence_cover',
      fileType: 'png',
      isSelected: true,
    },
  },
  reportLogo: {
    reportLogoList: [
      {
        uid: 'RJFWKXCD20221213041121',
        status: 'success',
        fileURL: null,
        isHover: false,
        fileName: 'logo组合白色',
        fileType: 'png',
        isSelected: false,
      },
    ],
    currentReportLogo: {
      uid: 'RJFWKXCD20221213041121',
      status: 'success',
      fileURL: null,
      isHover: false,
      fileName: 'logo组合白色',
      fileType: 'png',
      isSelected: false,
    },
    logoPosition: '中上',
    logoSize: 54,
    logoSizeConfig: {
      checkLogoSize: '40.5',
      checkLogoSizeObject: {
        label: '54px',
        ptValue: '40.5',
        pxValue: '54',
      },
    },
    logoPositionConfig: {
      checkClientX: '100',
      checkClientY: '100',
      useCheckPositionType: '',
    },
    reportTitle: '投资尽调分析',
    reportTitleConfig: {
      reportTitle: '报告标题',
      checkClientX: '60',
      checkClientY: '220',
      useCheckPositionType: '',
      checkFontSize: '80.25',
      checkFontSizeObject: {
        label: '107px',
        ptValue: '80.25',
        pxValue: '107',
      },
      checkFontColor: '#ffffff',
    },
    channelCompanyName: 'xxxx科技有限公司',
    channelCompanyNameConfig: {
      checkClientX: '257',
      checkClientY: '235',
      useCheckPositionType: 'level_center',
      checkFontSize: '24',
      checkFontSizeObject: {
        label: '32px',
        ptValue: '24',
        pxValue: '32',
      },
      checkFontColor: '#060E7D',
      checkBackgroundColor: '',
    },
    checkEnterprise: {
      checkClientX: '60',
      checkClientY: '970',
      useCheckPositionType: '',
      checkFontSize: '18',
      checkFontSizeObject: {
        label: '24px',
        ptValue: '18',
        pxValue: '24',
      },
      checkFontColor: '#1B3D7A',
    },
    isUseReportCreateTime: true,
    reportCreateTimeGrain: 'grain_second',
    reportCreateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    javaReportCreateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
    reportCreateTimePosition: {
      checkClientX: '60',
      checkClientY: '1020',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
      checkFontColor: '#1B3D7A',
    },
    checkEnterprisePreTitle: '检测企业',
    reportCreateTimePreTitle: '报告生成时间',
  },
  statementInfo: {
    label: '样式一',
    value: '1',
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligenceStatementInfo1/KQUFVXGC20230515065914',
    isLabelSelect: true,
    textarea:
      '1、本报告以被调研企业授权的申报数据及第三方公开、权威的数据为基础，综合运用多种统计分析方法，对其多维度数据做全面地分析，客观评价企业投资价值，并提示可能存在的相关风险。\n\n2、我司在执行本次企业调查分析中，遵循有关法律、法规，恪守独立、客观、公正、保密的原则为客户提供投资尽职调查服务。\n\n3、我司对被调研企业不存在任何偏见，调查报告陈述的内容是客观的，不构成我司对任何人、任何企业做明示或暗示的观点或保证。尽调报告内容受数据基数的限制可能会有误差，仅供参考。\n\n4、本报告行业发展环境相关部分涉及的行业为授权企业所处一级或二级行业，主要以二级为准，文中无特指宏观大行业下均指报告选定的研究样本范围。此外，关于行业相关数据，公司不单独留存单企业原始数据，只对行业整体画像进行研究分析。\n\n5、本报告中的分析、判断和结论受提供的数据、限定条件等的限制，调查报告使用者应当充分考虑报告中载明的假设、限定条件、特别事项说明及其对调查结论的影响。',
  },
  catalogueConfig: {
    label: '样式一',
    value: '1',
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_catalogueConfig1/PMKTMBWJ20230515070417',
    isLabelSelect: true,
    selectModel: '3',
    isUsePageNumbers: true,
  },
  summaryConfig: {
    label: '样式一',
    value: 1,
    isLabelSelect: true,
    displayType: '1',
  },
  summaryConfigTwo: {
    label: '样式一',
    value: 1,
    isLabelSelect: true,
  },
  reportThemeColor: {
    currentReportThemeColor: '#3881F8',
    currentReportThemeColorRGB: '56, 129, 248',
  },
  labelSelect: {
    label: '样式一',
    value: '1',
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/h1/UYMKMXGD20230627023503',
    isLabelSelect: true,
    imgConfig: {},
  },
  customUploadHeaderStyle: {
    img: '',
    type: 'customUpload',
    label: '自定义上传',
    value: '1000',
    imgConfig: {},
    isLabelSelect: false,
  },
  riskTip: {
    img: 'static/img/riskTip_config1.19f15420.png',
    label: '样式一',
    value: '1',
    isLabelSelect: true,
  },
  riskTipPosition: 'top',
  moduleInterpretation: {
    colorConfig: '#2CA58D',
    fontSizeConfig: '9',
    fontSizeConfigObject: {
      label: '12px',
      ptValue: '9',
      pxValue: '12',
    },
  },
  watermark: 'off',
  reportWatermark: '',
  // 是否使用logo，作为水印图片
  isUseReportWatermarkImage: false,
  // 水印图片
  reportWatermarkImage: '',
  pageNumber: 'on',
  pageNumberPosition: 'right',
  isUseLawsRule: true,
  lawsRuleConfig: {
    display_mode: 'disperse',
  },
  tableStyle: {
    label: '样式一',
    value: '1',
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/tableStyle_config1/GKNZQWZM20230209033844',
    isLabelSelect: true,
  },
  tableColorConfig: {
    useColorType: 'themeColor',
    customTableColor: '#3881F8',
  },
  titleStyle: {
    title: '标题样式',
    selectType: 'tabSelect',
    config: [
      {
        tabName: '一级标题',
        value: 'tab1',
        tabSelect: true,
        tabList: [
          {
            label: '样式一',
            value: 'tab1_label1',
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t1/YXZCJYQD20230627023136',
            isLabelSelect: true,
          },
        ],
      },
      {
        value: 'tab2',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t2/SLYTVJXL20230627023228',
            label: '样式一',
            value: 'tab2_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '二级标题',
        tabSelect: false,
      },
      {
        value: 'tab3',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t3/OHQHODQI20230627023323',
            label: '样式一',
            value: 'tab3_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '三级标题',
        tabSelect: false,
      },
    ],
  },
  footerConfig: {
    // logo大小
    logoSize: 54,
    // logo大小配置对象
    logoSizeConfig: {
      checkLogoSize: '40.5',
      checkLogoSizeObject: {
        label: '54px',
        ptValue: '40.5',
        pxValue: '54',
      },
    },
    logoPositionConfig: {
      checkClientX: '370',
      checkClientY: '235',
      useCheckPositionType: '',
    },
    footerLogoImage: {},
    footerCoverList: [
      {
        uid: 'GRDMIQLT20230614055208',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/f1/GRDMIQLT20230614055208',
        isHover: false,
        fileName: 'f1',
        fileType: 'png',
        isSelected: true,
      },
    ],
    currentFooterCover: {
      uid: 'GRDMIQLT20230614055208',
      status: 'success',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/f1/GRDMIQLT20230614055208',
      isHover: false,
      fileName: 'f1',
      fileType: 'png',
      isSelected: true,
    },
    footerLogo: {
      uid: '',
      fileURL: null,
      isHover: false,
      fileName: '',
      fileType: '',
      isSelected: false,
    },
    otherConfig: {
      label: '样式一',
      value: '1',
      img: 'static/img/第一套尾页.b191943f.png',
      isLabelSelect: true,
      contactNumber: '138568xxxxxxx',
      addressArea: '这是一段测试的地址',
      QRCodeDescription: '微信公众号',
    },
    footerDescConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerAddressConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#1b3d7a',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerTelConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#1b3d7a',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
  },
}
// 财政补贴
const fiscal_subsidies = {
  reportDisplayType: 'tight',
  watermarkOpacity: 10,
  riskTip: {
    img: 'static/img/riskTip_config1.19f15420.png',
    label: '样式一',
    value: '1',
    isLabelSelect: true,
  },
  watermark: 'off',
  pageNumber: 'on',
  pageNumberPosition: 'right',
  reportLogo: {
    logoSize: 54,
    reportTitle: '企业尽调报告',
    logoPosition: '中上',
    logoSizeConfig: {
      checkLogoSize: '40.5',
      checkLogoSizeObject: {
        label: '54px',
        ptValue: '40.5',
        pxValue: '54',
      },
    },
    logoPositionConfig: {
      checkClientX: '100',
      checkClientY: '100',
      useCheckPositionType: '',
    },
    reportLogoList: [
      {
        uid: 'RJFWKXCD20221213041121',
        status: 'success',
        fileURL: null,
        isHover: false,
        fileName: 'logo组合白色',
        fileType: 'png',
        isSelected: false,
      },
    ],
    checkEnterprise: {
      checkClientX: '80',
      checkClientY: '430',
      checkFontSize: '22.5',
      checkFontColor: '#FF9500',
      checkFontSizeObject: {
        label: '30px',
        ptValue: '22.5',
        pxValue: '30',
      },
      useCheckPositionType: '',
    },
    currentReportLogo: {
      uid: 'RJFWKXCD20221213041121',
      status: 'success',
      fileURL: null,
      isHover: false,
      fileName: 'logo组合白色',
      fileType: 'png',
      isSelected: false,
    },
    reportTitleConfig: {
      reportTitle: '报告标题',
      checkClientX: '80',
      checkClientY: '270',
      checkFontSize: '80.25',
      checkFontColor: '#FF9500',
      checkFontSizeObject: {
        label: '107px',
        ptValue: '80.25',
        pxValue: '107',
      },
      useCheckPositionType: '',
    },
    channelCompanyName: 'xxxx科技有限公司',
    isUseReportCreateTime: true,
    reportCreateTimeGrain: 'grain_second',
    reportCreateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    checkEnterprisePreTitle: '检测企业',
    channelCompanyNameConfig: {
      checkClientX: '257',
      checkClientY: '235',
      checkFontSize: '24',
      checkFontColor: '#060E7D',
      checkBackgroundColor: '',
      channelCompanyName: 'xxxx科技有限公司',
      checkFontSizeObject: {
        label: '32px',
        ptValue: '24',
        pxValue: '32',
      },
      useCheckPositionType: 'level_center',
    },
    reportCreateTimePosition: {
      checkClientX: '80',
      checkClientY: '1000',
      checkFontSize: '18',
      checkFontColor: '#ffffff',
      checkFontSizeObject: {
        label: '24px',
        ptValue: '18',
        pxValue: '24',
      },
      useCheckPositionType: '',
    },
    reportCreateTimePreTitle: '报告生成时间',
    javaReportCreateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
  },
  tableStyle: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/tableStyle_config1/GKNZQWZM20230209033844',
    label: '样式一',
    value: '1',
    isLabelSelect: true,
  },
  titleStyle: {
    title: '标题样式',
    config: [
      {
        value: 'tab1',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_titleStyle_firstLevel1/QUJLQFRJ20230515070930',
            label: '样式一',
            value: 'tab1_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '一级标题',
        tabSelect: true,
      },
      {
        value: 'tab2',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_titleStyle_secondLevel1/QBCRTHGZ20230515072722',
            label: '样式一',
            value: 'tab2_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '二级标题',
        tabSelect: false,
      },
    ],
    selectType: 'tabSelect',
  },
  labelSelect: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_labelSelect1/VTSWHPMN20230515070734',
    label: '样式一',
    value: '1',
    isLabelSelect: true,
    imgConfig: {},
  },
  customUploadHeaderStyle: {
    img: '',
    type: 'customUpload',
    label: '自定义上传',
    value: '1000',
    imgConfig: {},
    isLabelSelect: false,
  },
  reportCover: {
    reportCoverList: [
      {
        uid: 'CBLKSJYP20231013093807',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/12/CBLKSJYP20231013093807',
        isHover: false,
        fileName: '12',
        fileType: 'png',
        isSelected: true,
      },
    ],
    currentReportCover: {
      uid: 'CBLKSJYP20231013093807',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/12/CBLKSJYP20231013093807',
      isHover: false,
      fileName: '12',
      fileType: 'png',
      isSelected: true,
    },
  },
  footerConfig: {
    // logo大小
    logoSize: 54,
    // logo大小配置对象
    logoSizeConfig: {
      checkLogoSize: '40.5',
      checkLogoSizeObject: {
        label: '54px',
        ptValue: '40.5',
        pxValue: '54',
      },
    },
    logoPositionConfig: {
      checkClientX: '370',
      checkClientY: '235',
      useCheckPositionType: '',
    },
    footerLogoImage: {},
    footerLogo: {
      uid: '',
      fileURL: null,
      isHover: false,
      fileName: '',
      fileType: '',
      isSelected: false,
    },
    otherConfig: {
      img: 'static/img/第一套尾页.b191943f.png',
      label: '样式一',
      value: '1',
      addressArea: '这是一段测试的地址',
      contactNumber: '138568xxxxxxx',
      isLabelSelect: true,
      QRCodeDescription: '微信公众号',
    },
    footerCoverList: [
      {
        uid: 'PGSKHJRS20230515071337',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_footerConfig1/PGSKHJRS20230515071337',
        isHover: false,
        fileName: 'dueDiligence_footerConfig1',
        fileType: 'png',
        isSelected: true,
      },
    ],
    currentFooterCover: {
      uid: 'PGSKHJRS20230515071337',
      status: 'success',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_footerConfig1/PGSKHJRS20230515071337',
      isHover: false,
      fileName: 'dueDiligence_footerConfig1',
      fileType: 'png',
      isSelected: true,
    },
    footerDescConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerAddressConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#333333',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerTelConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#333333',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
  },
  isUseLawsRule: true,
  statementInfo: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligenceStatementInfo1/KQUFVXGC20230515065914',
    label: '样式一',
    value: '1',
    textarea:
      '1、本报告的数据基于被检测企业授权的申报表等数据，以大数据建模、数据挖掘技术为基础，对被检测企业的数据进行分析，给被检测企业的申报情况和税收健康状况提供一个客观的评价。\n\n2、本报告的财务基础指标模块、企业所得税模块的部分数据取自所得税附表。目前浙江、广东、陕西、江苏、上海、天津、辽宁、贵州、内蒙古、北京、湖南（部分）、深圳（部分）、四川（部分）、山东（部分）、福建、海南、甘肃、宁波已开放附表数据其它省份后续开放。\n\n3、我司在执行本次财税风险检测业务中，遵循有关法律、法规，恪守独立、客观、公正、保密的原则，对委托企业进行税务风险体检。\n\n4、我司对被检测企业不存在任何偏见，检测报告陈述的内容是客观的，不构成我司对任何人、任何企业做明示或暗示的观点或保证。检测报告内容受数据基数的限制可能会有误差，仅供参考。\n\n5、我司出具的检测报告中的分析、判断和结论受提供的数据、限定条件和检测方法的限制，检测报告使用者应当充分考虑检测报告中载明的假设、限定条件、特别事项说明及其对检测结论的影响。\n\n6、感谢您对我司企业财税风险检测系统信任，配合我们顺利完成了本次风险检测。',
    isLabelSelect: true,
  },
  summaryConfig: {
    label: '样式一',
    value: 1,
    isLabelSelect: true,
    displayType: '1',
  },
  lawsRuleConfig: {
    display_mode: 'disperse',
  },
  catalogueConfig: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_catalogueConfig1/PMKTMBWJ20230515070417',
    label: '样式一',
    value: '1',
    selectModel: '2',
    isLabelSelect: true,
    isUsePageNumbers: false,
  },
  reportWatermark: '',
  riskTipPosition: 'top',
  reportThemeColor: {
    currentReportThemeColor: '#FF9500',
    currentReportThemeColorRGB: '255, 149, 0',
    currentReportThemeColorPoint5: '#fffaf2',
    currentReportThemeColorPoint8: '#fff7eb',
    currentReportThemeColorPoint10: '#fff4e6',
  },
  summaryConfigTwo: {
    label: '样式一',
    value: 1,
    isLabelSelect: true,
  },
  tableColorConfig: {
    useColorType: 'themeColor',
    customTableColor: '#3881F8',
  },
  moduleInterpretation: {
    colorConfig: '#999999',
    fontSizeConfig: '9',
    fontSizeConfigObject: {
      label: '12px',
      ptValue: '9',
      pxValue: '12',
    },
  },
  reportWatermarkImage: '',
  isUseReportWatermarkImage: false,
}
// 税务风险报告-税优版
const taxRiskProfessional = {
  reportDisplayType: 'tight',
  watermarkOpacity: 10,
  reportCover: {
    reportCoverList: [
      {
        uid: 'VCIODECP20230613074504',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/invest_dueDiligence_cover/VCIODECP20230613074504',
        isHover: false,
        fileName: 'invest_dueDiligence_cover',
        fileType: 'png',
        isSelected: true,
      },
    ],
    currentReportCover: {
      uid: 'VCIODECP20230613074504',
      status: 'success',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/invest_dueDiligence_cover/VCIODECP20230613074504',
      isHover: false,
      fileName: 'invest_dueDiligence_cover',
      fileType: 'png',
      isSelected: true,
    },
  },
  reportLogo: {
    reportLogoList: [
      {
        uid: 'RJFWKXCD20221213041121',
        status: 'success',
        fileURL: null,
        isHover: false,
        fileName: 'logo组合白色',
        fileType: 'png',
        isSelected: false,
      },
    ],
    currentReportLogo: {
      uid: 'RJFWKXCD20221213041121',
      status: 'success',
      fileURL: null,
      isHover: false,
      fileName: 'logo组合白色',
      fileType: 'png',
      isSelected: false,
    },
    logoPosition: '中上',
    logoSize: 54,
    logoSizeConfig: {
      checkLogoSize: '40.5',
      checkLogoSizeObject: {
        label: '54px',
        ptValue: '40.5',
        pxValue: '54',
      },
    },
    logoPositionConfig: {
      checkClientX: '100',
      checkClientY: '100',
      useCheckPositionType: '',
    },
    reportTitle: '投资尽调分析',
    reportSubTitle: '(建筑业)',
    reportTitleConfig: {
      reportTitle: '报告标题',
      checkClientX: '60',
      checkClientY: '220',
      useCheckPositionType: '',
      checkFontSize: '80.25',
      checkFontSizeObject: {
        label: '107px',
        ptValue: '80.25',
        pxValue: '107',
      },
      checkFontColor: '#ffffff',
    },
    isUseIndustrySubTitle: true,
    // 报告行业子标题
    reportIndustrySubTitleConfig: {
      checkClientX: '270',
      checkClientY: '688',
      useCheckPositionType: '',
      checkFontSize: '33.75',
      checkFontSizeObject: { label: '45px', ptValue: '33.75', pxValue: '45' },
      checkFontColor: '#ffffff',
    },
    channelCompanyName: 'xxxx科技有限公司',
    channelCompanyNameConfig: {
      checkClientX: '257',
      checkClientY: '235',
      useCheckPositionType: 'level_center',
      checkFontSize: '24',
      checkFontSizeObject: {
        label: '32px',
        ptValue: '24',
        pxValue: '32',
      },
      checkFontColor: '#060E7D',
      checkBackgroundColor: '',
    },
    checkEnterprise: {
      checkClientX: '60',
      checkClientY: '970',
      useCheckPositionType: '',
      checkFontSize: '18',
      checkFontSizeObject: {
        label: '24px',
        ptValue: '18',
        pxValue: '24',
      },
      checkFontColor: '#1B3D7A',
    },
    isUseReportCreateTime: true,
    reportCreateTimeGrain: 'grain_second',
    reportCreateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    javaReportCreateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
    reportCreateTimePosition: {
      checkClientX: '60',
      checkClientY: '1020',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
      checkFontColor: '#1B3D7A',
    },
    checkEnterprisePreTitle: '检测企业',
    reportCreateTimePreTitle: '报告生成时间',
  },
  statementInfo: {
    label: '样式一',
    value: '1',
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligenceStatementInfo1/KQUFVXGC20230515065914',
    isLabelSelect: true,
    textarea:
      '1、本报告以被调研企业授权的申报数据及第三方公开、权威的数据为基础，综合运用多种统计分析方法，对其多维度数据做全面地分析，客观评价企业投资价值，并提示可能存在的相关风险。\n\n2、我司在执行本次企业调查分析中，遵循有关法律、法规，恪守独立、客观、公正、保密的原则为客户提供投资尽职调查服务。\n\n3、我司对被调研企业不存在任何偏见，调查报告陈述的内容是客观的，不构成我司对任何人、任何企业做明示或暗示的观点或保证。尽调报告内容受数据基数的限制可能会有误差，仅供参考。\n\n4、本报告行业发展环境相关部分涉及的行业为授权企业所处一级或二级行业，主要以二级为准，文中无特指宏观大行业下均指报告选定的研究样本范围。此外，关于行业相关数据，公司不单独留存单企业原始数据，只对行业整体画像进行研究分析。\n\n5、本报告中的分析、判断和结论受提供的数据、限定条件等的限制，调查报告使用者应当充分考虑报告中载明的假设、限定条件、特别事项说明及其对调查结论的影响。',
  },
  catalogueConfig: {
    label: '样式一',
    value: '1',
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_catalogueConfig1/PMKTMBWJ20230515070417',
    isLabelSelect: true,
    selectModel: '3',
    isUsePageNumbers: true,
  },
  summaryConfig: {
    label: '样式一',
    value: 1,
    isLabelSelect: true,
    displayType: '1',
  },
  summaryConfigTwo: {
    label: '样式一',
    value: 1,
    isLabelSelect: true,
  },
  reportThemeColor: {
    currentReportThemeColor: '#3881F8',
    currentReportThemeColorRGB: '56, 129, 248',
  },
  labelSelect: {
    label: '样式一',
    value: '1',
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/h1/UYMKMXGD20230627023503',
    imgConfig: {},
    isLabelSelect: true,
  },
  customUploadHeaderStyle: {
    img: '',
    type: 'customUpload',
    label: '自定义上传',
    value: '1000',
    imgConfig: {},
    isLabelSelect: false,
  },
  riskTip: {
    img: 'static/img/riskTip_config1.19f15420.png',
    label: '样式一',
    value: '1',
    isLabelSelect: true,
  },
  riskTipPosition: 'top',
  moduleInterpretation: {
    colorConfig: '#2CA58D',
    fontSizeConfig: '9',
    fontSizeConfigObject: {
      label: '12px',
      ptValue: '9',
      pxValue: '12',
    },
  },
  watermark: 'off',
  reportWatermark: '',
  // 是否使用logo，作为水印图片
  isUseReportWatermarkImage: false,
  // 水印图片
  reportWatermarkImage: '',
  pageNumber: 'on',
  pageNumberPosition: 'right',
  isUseLawsRule: true,
  lawsRuleConfig: {
    display_mode: 'disperse',
  },
  tableStyle: {
    label: '样式一',
    value: '1',
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/tableStyle_config1/GKNZQWZM20230209033844',
    isLabelSelect: true,
  },
  tableColorConfig: {
    useColorType: 'themeColor',
    customTableColor: '#3881F8',
  },
  titleStyle: {
    title: '标题样式',
    selectType: 'tabSelect',
    config: [
      {
        tabName: '一级标题',
        value: 'tab1',
        tabSelect: true,
        tabList: [
          {
            label: '样式一',
            value: 'tab1_label1',
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t1/YXZCJYQD20230627023136',
            isLabelSelect: true,
          },
        ],
      },
      {
        value: 'tab2',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t2/SLYTVJXL20230627023228',
            label: '样式一',
            value: 'tab2_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '二级标题',
        tabSelect: false,
      },
      {
        value: 'tab3',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t3/OHQHODQI20230627023323',
            label: '样式一',
            value: 'tab3_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '三级标题',
        tabSelect: false,
      },
    ],
  },
  footerConfig: {
    // logo大小
    logoSize: 54,
    // logo大小配置对象
    logoSizeConfig: {
      checkLogoSize: '40.5',
      checkLogoSizeObject: {
        label: '54px',
        ptValue: '40.5',
        pxValue: '54',
      },
    },
    logoPositionConfig: {
      checkClientX: '370',
      checkClientY: '235',
      useCheckPositionType: '',
    },
    footerLogoImage: {},
    footerCoverList: [
      {
        uid: 'GRDMIQLT20230614055208',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/f1/GRDMIQLT20230614055208',
        isHover: false,
        fileName: 'f1',
        fileType: 'png',
        isSelected: true,
      },
    ],
    currentFooterCover: {
      uid: 'GRDMIQLT20230614055208',
      status: 'success',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/f1/GRDMIQLT20230614055208',
      isHover: false,
      fileName: 'f1',
      fileType: 'png',
      isSelected: true,
    },
    footerLogo: {
      uid: '',
      fileURL: null,
      isHover: false,
      fileName: '',
      fileType: '',
      isSelected: false,
    },
    otherConfig: {
      label: '样式一',
      value: '1',
      img: 'static/img/第一套尾页.b191943f.png',
      isLabelSelect: true,
      contactNumber: '138568xxxxxxx',
      addressArea: '这是一段测试的地址',
      QRCodeDescription: '微信公众号',
    },
    footerDescConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerAddressConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#333333',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerTelConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#333333',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
  },
}
// 融资服务
const financeService = {
  reportDisplayType: 'tight',
  watermarkOpacity: 10,
  riskTip: {
    img: 'static/img/riskTip_config1.19f15420.png',
    label: '样式一',
    value: '1',
    isLabelSelect: true,
  },
  watermark: 'off',
  pageNumber: 'on',
  pageNumberPosition: 'right',
  isUseLoanAmount: true,
  isUseProductQRCode: true,
  reportLogo: {
    logoSize: 54,
    reportTitle: '融资匹配分析报告',
    logoPosition: '中上',
    logoSizeConfig: {
      checkLogoSize: '40.5',
      checkLogoSizeObject: {
        label: '54px',
        ptValue: '40.5',
        pxValue: '54',
      },
    },
    logoPositionConfig: {
      checkClientX: '100',
      checkClientY: '100',
      useCheckPositionType: '',
    },
    reportLogoList: [
      {
        uid: 'RJFWKXCD20221213041121',
        status: 'success',
        fileURL: null,
        isHover: false,
        fileName: 'logo组合白色',
        fileType: 'png',
        isSelected: false,
      },
    ],
    checkEnterprise: {
      checkClientX: '46',
      checkClientY: '840',
      checkFontSize: '18',
      checkFontColor: '#333333',
      checkFontSizeObject: {
        label: '24px',
        ptValue: '18',
        pxValue: '24',
      },
      useCheckPositionType: '',
    },
    currentReportLogo: {
      uid: 'RJFWKXCD20221213041121',
      status: 'success',
      fileURL: null,
      isHover: false,
      fileName: 'logo组合白色',
      fileType: 'png',
      isSelected: false,
    },
    reportTitleConfig: {
      reportTitle: '报告标题',
      checkClientX: '46',
      checkClientY: '580',
      checkFontSize: '63.75',
      checkFontColor: '#333333',
      checkFontSizeObject: {
        label: '85px',
        ptValue: '63.75',
        pxValue: '85',
      },
      useCheckPositionType: '',
    },
    channelCompanyName: '',
    isUseReportCreateTime: true,
    reportCreateTimeGrain: 'grain_second',
    reportCreateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    checkEnterprisePreTitle: '检测企业',
    channelCompanyNameConfig: {
      checkClientX: '46',
      checkClientY: '480',
      checkFontSize: '42',
      checkFontColor: '#333333',
      channelCompanyName: 'xxxx科技有限公司',
      checkFontSizeObject: {
        label: '56px',
        ptValue: '42',
        pxValue: '56',
      },
      checkBackgroundColor: '',
      useCheckPositionType: '',
    },
    reportCreateTimePosition: {
      checkClientX: '46',
      checkClientY: '902',
      checkFontSize: '15.75',
      checkFontColor: '#333333',
      checkFontSizeObject: {
        label: '21px',
        ptValue: '15.75',
        pxValue: '21',
      },
      useCheckPositionType: '',
    },
    reportCreateTimePreTitle: '报告生成时间',
    javaReportCreateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
  },
  tableStyle: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/tableStyle_config2/JBZSFVCC20230209033910',
    label: '样式二',
    value: '2',
    isLabelSelect: true,
  },
  titleStyle: {
    title: '标题样式',
    config: [
      {
        value: 'tab1',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t1/YXZCJYQD20230627023136',
            label: '样式一',
            value: 'tab1_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '一级标题',
        tabSelect: true,
      },
      {
        value: 'tab2',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t2/SLYTVJXL20230627023228',
            label: '样式一',
            value: 'tab2_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '二级标题',
        tabSelect: false,
      },
      {
        value: 'tab3',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t3/OHQHODQI20230627023323',
            label: '样式一',
            value: 'tab3_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '三级标题',
        tabSelect: false,
      },
    ],
    selectType: 'tabSelect',
  },
  labelSelect: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/h1/UYMKMXGD20230627023503',
    label: '样式一',
    value: '1',
    imgConfig: {},
    isLabelSelect: true,
  },
  customUploadHeaderStyle: {
    img: '',
    type: 'customUpload',
    label: '自定义上传',
    value: '1000',
    imgConfig: {},
    isLabelSelect: false,
  },
  reportCover: {
    reportCoverList: [
      {
        uid: 'CKIXYHVD20240304033052',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1709537422980/CKIXYHVD20240304033052',
        isHover: false,
        fileName: '1709537422980',
        fileType: 'jpg',
        isSelected: true,
      },
    ],
    currentReportCover: {
      uid: 'CKIXYHVD20240304033052',
      status: 'success',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/1709537422980/CKIXYHVD20240304033052',
      isHover: false,
      fileName: '1709537422980',
      fileType: 'jpg',
      isSelected: true,
    },
  },
  footerConfig: {
    // logo大小
    logoSize: 54,
    // logo大小配置对象
    logoSizeConfig: {
      checkLogoSize: '40.5',
      checkLogoSizeObject: {
        label: '54px',
        ptValue: '40.5',
        pxValue: '54',
      },
    },
    logoPositionConfig: {
      checkClientX: '370',
      checkClientY: '235',
      useCheckPositionType: '',
    },
    footerLogoImage: {},
    footerLogo: {
      uid: '',
      fileURL: null,
      isHover: false,
      fileName: '',
      fileType: '',
      isSelected: false,
    },
    otherConfig: {
      img: 'static/img/第一套尾页.b191943f.png',
      label: '样式一',
      value: '1',
      addressArea: '这是一段测试的地址',
      contactNumber: '138568xxxxxxx',
      isLabelSelect: true,
      QRCodeDescription: '微信公众号',
    },
    footerCoverList: [
      {
        uid: 'WPHMLTWU20240304050057',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/17092000452403/WPHMLTWU20240304050057',
        isHover: false,
        fileName: '17092000452403',
        fileType: 'png',
        isSelected: true,
      },
    ],
    currentFooterCover: {
      uid: 'WPHMLTWU20240304050057',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/17092000452403/WPHMLTWU20240304050057',
      isHover: false,
      fileName: '17092000452403',
      fileType: 'png',
      isSelected: true,
    },
    footerDescConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#333333',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerAddressConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerTelConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
  },
  isUseLawsRule: true,
  statementInfo: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligenceStatementInfo1/KQUFVXGC20230515065914',
    label: '样式一',
    value: '1',
    textarea:
      '为了帮助企业有效的了解并管理，企业可能面临税务合规性不足、税收筹划不严谨等多种风险。本报告会对企业的发票结构、财报和税务指标进行全面诊断，并结合大数据分析，提供各项指标的合理范围，具体包括以下几个方面： \n\n1、增值税风险分析：通过分析企业的发票结构，包括发票种类、开票价税、客户类别等情况，从开具增值税发票、接收增值税发票、确认增值税收入、申报抵扣增值税等角度进行综合分析，结合行业特性，提示企业可能存在的虚开、采购发票异常、申报抵扣异常等在内的问题，并提供相应的解决方案和法规依据。 \n\n2、企业所得税风险分析：通过对企业的财务报表、税务申报情况和发票数据进行比对分析，结合财报指标和税务指标，并与同行业企业指标分布情况进行比对，帮助企业自身结合内部基础数据，发现缴纳企业所得税中可能存在的账务漏洞、可能存在的漏报错报、可能涉及的偷逃税等问题，并提供相应的解决方案和法规依据。\n \n3、小税种分析：通过将对企业的财务报表、税务申报情况和发票数据进行比对，发现其中的不一致，提醒企业可能存在的漏报错报等问题，并提供相应的解决方案和法规依据。\n \n4、本报告的财务基础指标模块、企业所得税模块的部分数据取自所得税附表。目前已支持浙江、广东、陕西、江苏、上 海、天津、辽宁、贵州、内蒙古、北京、湖南（部分）、深圳（部分）、四川（部分）、山东（部分）、福建、海南、甘肃、宁波、江西已开放附表数据其它省份后续开放。 \n\n本报告仅供签约客户检测企业的申报情况和税收健康状况，给企业的经营等及其他决策做参考。我司在执行本次财税风险检测业务中，遵循有关法律、客观、公正、保密的原则，对检测报告的内容作客观陈述，不构成我司对任何人、任何企业做任何保证。我司不承担使用者的任何商业风险，也不承担由于其非控因素和疏忽而引起的相应的损失和损害，检测报告内容受数据基数的限制可能会有误差，仅供参考。 ',
    isLabelSelect: true,
  },
  summaryConfig: {
    label: '样式一',
    value: 1,
    displayType: '1',
    isLabelSelect: true,
  },
  lawsRuleConfig: {
    display_mode: 'disperse',
  },
  catalogueConfig: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_catalogueConfig1/PMKTMBWJ20230515070417',
    label: '样式一',
    value: '1',
    selectModel: '3',
    isLabelSelect: true,
    isUsePageNumbers: true,
  },
  reportWatermark: '',
  riskTipPosition: 'top',
  reportThemeColor: {
    currentReportThemeColor: '#04A9F3',
    currentReportThemeColorRGB: '4, 169, 243',
    currentReportThemeColorPoint5: '#f2fbfe',
    currentReportThemeColorPoint8: '#ebf8fe',
    currentReportThemeColorPoint10: '#e6f6fe',
  },
  summaryConfigTwo: {
    label: '样式一',
    value: 1,
    isLabelSelect: true,
  },
  tableColorConfig: {
    useColorType: 'themeColor',
    customTableColor: '#3881F8',
  },
  moduleInterpretation: {
    colorConfig: '#2CA58D',
    fontSizeConfig: '9',
    fontSizeConfigObject: {
      label: '12px',
      ptValue: '9',
      pxValue: '12',
    },
  },
  reportWatermarkImage: '',
  isUseReportWatermarkImage: false,
}
// 企业全景报告
const panoramicAnalysis = {
  reportDisplayType: 'tight',
  watermarkOpacity: 10,
  riskTip: {
    img: 'static/img/riskTip_config1.19f15420.png',
    label: '样式一',
    value: '1',
    isLabelSelect: true,
  },
  watermark: 'off',
  pageNumber: 'on',
  pageNumberPosition: 'right',
  reportLogo: {
    logoSize: 60,
    reportTitle: '企业全景报告',
    logoPosition: '中上',
    logoSizeConfig: {
      checkLogoSize: 45,
      checkLogoSizeObject: {
        label: '60px',
        ptValue: 45,
        pxValue: 60,
      },
    },
    reportLogoList: [],
    checkEnterprise: {
      checkClientX: '60',
      checkClientY: '1000',
      checkFontSize: '11.25',
      checkFontColor: '#999999',
      checkFontSizeObject: {
        label: '15px',
        ptValue: '11.25',
        pxValue: '15',
      },
      useCheckPositionType: '',
    },
    currentReportLogo: {
      uid: 'RJFWKXCD20221213041121',
      status: 'success',
      fileURL: null,
      isHover: false,
      fileName: 'logo组合白色',
      fileType: 'png',
      isSelected: false,
    },
    reportTitleConfig: {
      reportTitle: '报告标题',
      checkClientX: '58',
      checkClientY: '820',
      checkFontSize: '67.5',
      checkFontColor: '#2654A2',
      checkFontSizeObject: {
        label: '90px',
        ptValue: '67.5',
        pxValue: '90',
      },
      useCheckPositionType: '',
    },
    channelCompanyName: '杭州**科技有限公司',
    logoPositionConfig: {
      checkClientX: '60',
      checkClientY: '100',
      useCheckPositionType: '',
    },
    isUseReportCreateTime: true,
    reportCreateTimeGrain: 'grain_second',
    reportCreateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    checkEnterprisePreTitle: '检测企业',
    channelCompanyNameConfig: {
      checkClientX: '60',
      checkClientY: '774',
      checkFontSize: '15',
      checkFontColor: '#333333',
      channelCompanyName: 'xxxx科技有限公司',
      checkFontSizeObject: {
        label: '20px',
        ptValue: '15',
        pxValue: '20',
      },
      checkBackgroundColor: '',
      useCheckPositionType: '',
    },
    reportCreateTimePosition: {
      checkClientX: '480',
      checkClientY: '1000',
      checkFontSize: '11.25',
      checkFontColor: '#999999',
      checkFontSizeObject: {
        label: '15px',
        ptValue: '11.25',
        pxValue: '15',
      },
      useCheckPositionType: '',
    },
    reportCreateTimePreTitle: '报告生成时间',
    javaReportCreateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
  },
  tableStyle: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/tableStyle_config2/JBZSFVCC20230209033910',
    label: '样式二',
    value: '2',
    isLabelSelect: true,
  },
  titleStyle: {
    title: '标题样式',
    config: [
      {
        value: 'tab1',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t1/YXZCJYQD20230627023136',
            label: '样式一',
            value: 'tab1_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '一级标题',
        tabSelect: true,
      },
      {
        value: 'tab2',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t2/SLYTVJXL20230627023228',
            label: '样式一',
            value: 'tab2_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '二级标题',
        tabSelect: false,
      },
      {
        value: 'tab3',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t3/OHQHODQI20230627023323',
            label: '样式一',
            value: 'tab3_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '三级标题',
        tabSelect: false,
      },
    ],
    selectType: 'tabSelect',
  },
  labelSelect: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/h1/UYMKMXGD20230627023503',
    label: '样式一',
    value: '1',
    imgConfig: {},
    isLabelSelect: true,
  },
  reportCover: {
    reportCoverList: [
      {
        uid: 'UNXTBQCP20240603014150',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/UNXTBQCP20240603014150',
        isHover: false,
        fileName: '1',
        fileType: 'png',
        isSelected: true,
      },
    ],
    currentReportCover: {
      uid: 'UNXTBQCP20240603014150',
      status: 'success',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/UNXTBQCP20240603014150',
      isHover: false,
      fileName: '1',
      fileType: 'png',
      isSelected: true,
    },
  },
  footerConfig: {
    logoSize: 54,
    footerLogo: {
      uid: '',
      fileURL: null,
      isHover: false,
      fileName: '',
      fileType: '',
      isSelected: false,
    },
    otherConfig: {
      img: 'static/img/第一套尾页.b191943f.png',
      label: '样式一',
      value: '1',
      addressArea: '这是一段测试的地址',
      contactNumber: '138568xxxxxxx',
      isLabelSelect: true,
      QRCodeDescription: '微信公众号',
    },
    logoSizeConfig: {
      checkLogoSize: '40.5',
      checkLogoSizeObject: {
        label: '54px',
        ptValue: '40.5',
        pxValue: '54',
      },
    },
    footerCoverList: [
      {
        uid: 'VYEBSQFC20240603073619',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/VYEBSQFC20240603073619',
        isHover: false,
        fileName: 'f',
        fileType: 'png',
        isSelected: true,
      },
    ],
    footerLogoImage: {},
    currentFooterCover: {
      uid: 'VYEBSQFC20240603073619',
      status: 'success',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/VYEBSQFC20240603073619',
      isHover: false,
      fileName: 'f',
      fileType: 'png',
      isSelected: true,
    },
    logoPositionConfig: {
      checkClientX: '370',
      checkClientY: '235',
      useCheckPositionType: '',
    },
    footerDescConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerAddressConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerTelConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#ffffff',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
  },
  isUseLawsRule: true,
  statementInfo: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligenceStatementInfo1/KQUFVXGC20230515065914',
    label: '样式一',
    value: '1',
    textarea:
      '1、本报告对以下方面的每个小模块信息展示数量设置上限：30条。其中包括：（二）关系信息；（三）司法信息；（四）经营风险；（六）经营状况；（七）知识产权。\n\n2、企业年报展示年度为：近3年。',
    isLabelSelect: true,
  },
  summaryConfig: {
    label: '样式一',
    value: 1,
    displayType: '1',
    isLabelSelect: true,
  },
  lawsRuleConfig: {
    display_mode: 'disperse',
  },
  catalogueConfig: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_catalogueConfig1/PMKTMBWJ20230515070417',
    label: '样式一',
    value: '1',
    selectModel: '3',
    isLabelSelect: true,
    isUsePageNumbers: true,
  },
  reportWatermark: '',
  riskTipPosition: 'top',
  reportThemeColor: {
    currentReportThemeColor: '#2654A2',
    currentReportThemeColorRGB: '38, 84, 162',
    currentReportThemeColorPoint5: '#f4f6fa',
    currentReportThemeColorPoint8: '#eef1f8',
    currentReportThemeColorPoint10: '#e9eef6',
  },
  summaryConfigTwo: {
    label: '样式一',
    value: 1,
    isLabelSelect: true,
  },
  tableColorConfig: {
    useColorType: 'themeColor',
    customTableColor: '#3881F8',
  },
  moduleInterpretation: {
    colorConfig: '#2CA58D',
    fontSizeConfig: '9',
    fontSizeConfigObject: {
      label: '12px',
      ptValue: '9',
      pxValue: '12',
    },
  },
  reportWatermarkImage: '',
  customUploadHeaderStyle: {
    img: '',
    type: 'customUpload',
    label: '自定义上传',
    value: '1000',
    imgConfig: {},
    isLabelSelect: false,
  },
  isUseReportWatermarkImage: false,
}
// 经营参谋
const businessStrategy = {
  reportDisplayType: 'tight',
  watermarkOpacity: 10,
  riskTip: {
    img: 'static/img/riskTip_config1.19f15420.png',
    label: '样式一',
    value: '1',
    isLabelSelect: true,
  },
  watermark: 'off',
  pageNumber: 'on',
  pageNumberPosition: 'right',
  reportLogo: {
    logoSize: 60,
    reportTitle: '企业全景报告',
    logoPosition: '中上',
    logoSizeConfig: {
      checkLogoSize: 45,
      checkLogoSizeObject: {
        label: '60px',
        ptValue: 45,
        pxValue: 60,
      },
    },
    reportLogoList: [],
    checkEnterprise: {
      checkClientX: '60',
      checkClientY: '1000',
      checkFontSize: '11.25',
      checkFontColor: '#999999',
      checkFontSizeObject: {
        label: '15px',
        ptValue: '11.25',
        pxValue: '15',
      },
      useCheckPositionType: '',
    },
    currentReportLogo: {
      uid: 'RJFWKXCD20221213041121',
      status: 'success',
      fileURL: null,
      isHover: false,
      fileName: 'logo组合白色',
      fileType: 'png',
      isSelected: false,
    },
    reportTitleConfig: {
      reportTitle: '报告标题',
      checkClientX: '58',
      checkClientY: '820',
      checkFontSize: '67.5',
      checkFontColor: '#2654A2',
      checkFontSizeObject: {
        label: '90px',
        ptValue: '67.5',
        pxValue: '90',
      },
      useCheckPositionType: '',
    },
    channelCompanyName: '杭州**科技有限公司',
    logoPositionConfig: {
      checkClientX: '60',
      checkClientY: '100',
      useCheckPositionType: '',
    },
    isUseReportCreateTime: true,
    reportCreateTimeGrain: 'grain_second',
    reportCreateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
    checkEnterprisePreTitle: '检测企业',
    channelCompanyNameConfig: {
      checkClientX: '60',
      checkClientY: '774',
      checkFontSize: '15',
      checkFontColor: '#333333',
      channelCompanyName: 'xxxx科技有限公司',
      checkFontSizeObject: {
        label: '20px',
        ptValue: '15',
        pxValue: '20',
      },
      checkBackgroundColor: '',
      useCheckPositionType: '',
    },
    reportCreateTimePosition: {
      checkClientX: '480',
      checkClientY: '1000',
      checkFontSize: '11.25',
      checkFontColor: '#999999',
      checkFontSizeObject: {
        label: '15px',
        ptValue: '11.25',
        pxValue: '15',
      },
      useCheckPositionType: '',
    },
    reportCreateTimePreTitle: '报告生成时间',
    javaReportCreateTimeFormat: 'yyyy-MM-dd HH:mm:ss',
  },
  tableStyle: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/tableStyle_config2/JBZSFVCC20230209033910',
    label: '样式二',
    value: '2',
    isLabelSelect: true,
  },
  titleStyle: {
    title: '标题样式',
    config: [
      {
        value: 'tab1',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t1/YXZCJYQD20230627023136',
            label: '样式一',
            value: 'tab1_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '一级标题',
        tabSelect: true,
      },
      {
        value: 'tab2',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t2/SLYTVJXL20230627023228',
            label: '样式一',
            value: 'tab2_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '二级标题',
        tabSelect: false,
      },
      {
        value: 'tab3',
        tabList: [
          {
            img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/t3/OHQHODQI20230627023323',
            label: '样式一',
            value: 'tab3_label1',
            isLabelSelect: true,
          },
        ],
        tabName: '三级标题',
        tabSelect: false,
      },
    ],
    selectType: 'tabSelect',
  },
  labelSelect: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/h1/UYMKMXGD20230627023503',
    label: '样式一',
    value: '1',
    imgConfig: {},
    isLabelSelect: true,
  },
  reportCover: {
    reportCoverList: [
      {
        uid: 'UNXTBQCP20240603014150',
        status: 'success',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/UNXTBQCP20240603014150',
        isHover: false,
        fileName: '1',
        fileType: 'png',
        isSelected: true,
      },
    ],
    currentReportCover: {
      uid: 'UNXTBQCP20240603014150',
      status: 'success',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/UNXTBQCP20240603014150',
      isHover: false,
      fileName: '1',
      fileType: 'png',
      isSelected: true,
    },
  },
  footerConfig: {
    logoSize: 54,
    footerLogo: {
      uid: 'GEEMKBGT20230307072849',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/footer_logo/GEEMKBGT20230307072849',
      isHover: false,
      fileName: '公众号logo',
      fileType: 'jpg',
      isSelected: false,
    },
    otherConfig: {
      img: 'static/img/第一套尾页.b191943f.png',
      label: '样式一',
      value: '1',
      addressArea: '这是一段测试的地址',
      contactNumber: '138568xxxxxxx',
      isLabelSelect: true,
      QRCodeDescription: '微信公众号',
    },
    logoSizeConfig: {
      checkLogoSize: '40.5',
      checkLogoSizeObject: {
        label: '54px',
        ptValue: '40.5',
        pxValue: '54',
      },
    },
    footerCoverList: [
      {
        uid: 'VYEBSQFC20240603073619',
        fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/VYEBSQFC20240603073619',
        isHover: false,
        fileName: 'f',
        fileType: 'png',
        isSelected: true,
      },
    ],
    footerLogoImage: {},
    currentFooterCover: {
      uid: 'VYEBSQFC20240603073619',
      status: 'success',
      fileURL: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/VYEBSQFC20240603073619',
      isHover: false,
      fileName: 'f',
      fileType: 'png',
      isSelected: true,
    },
    logoPositionConfig: {
      checkClientX: '370',
      checkClientY: '235',
      useCheckPositionType: '',
    },
    footerDescConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#000000',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerAddressConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#333333',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
    footerTelConfig: {
      checkClientX: '253',
      checkClientY: '1000',
      useCheckPositionType: '',
      checkFontSize: '12',
      checkFontColor: '#333333',
      checkFontSizeObject: {
        label: '16px',
        ptValue: '12',
        pxValue: '16',
      },
    },
  },
  isUseLawsRule: true,
  statementInfo: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligenceStatementInfo1/KQUFVXGC20230515065914',
    label: '样式一',
    value: '1',
    textarea:
      '1、本报告对以下方面的每个小模块信息展示数量设置上限：30条。其中包括：（二）关系信息；（三）司法信息；（四）经营风险；（六）经营状况；（七）知识产权。\n\n2、企业年报展示年度为：近3年。',
    isLabelSelect: true,
  },
  summaryConfig: {
    label: '样式一',
    value: 1,
    displayType: '1',
    isLabelSelect: true,
  },
  lawsRuleConfig: {
    display_mode: 'disperse',
  },
  catalogueConfig: {
    img: 'http://wuneng-public.oss-cn-hangzhou.aliyuncs.com/wp/infoConfig/dueDiligence_catalogueConfig1/PMKTMBWJ20230515070417',
    label: '样式一',
    value: '1',
    selectModel: '3',
    isLabelSelect: true,
    isUsePageNumbers: true,
  },
  reportWatermark: '',
  riskTipPosition: 'top',
  reportThemeColor: {
    currentReportThemeColor: '#2654A2',
    currentReportThemeColorRGB: '38, 84, 162',
    currentReportThemeColorPoint5: '#f4f6fa',
    currentReportThemeColorPoint8: '#eef1f8',
    currentReportThemeColorPoint10: '#e9eef6',
  },
  summaryConfigTwo: {
    label: '样式一',
    value: 1,
    isLabelSelect: true,
  },
  tableColorConfig: {
    useColorType: 'themeColor',
    customTableColor: '#3881F8',
  },
  moduleInterpretation: {
    colorConfig: '#2CA58D',
    fontSizeConfig: '9',
    fontSizeConfigObject: {
      label: '12px',
      ptValue: '9',
      pxValue: '12',
    },
  },
  reportWatermarkImage: '',
  customUploadHeaderStyle: {
    img: '',
    type: 'customUpload',
    label: '自定义上传',
    value: '1000',
    imgConfig: {},
    isLabelSelect: false,
  },
  isUseReportWatermarkImage: false,
}
